<!-- Confirma que está em 'minha-nova-branch'
git branch --show-current

# Edita arquivos, depois:
git add .
git commit -m "Implementa tal funcionalidade X"

# Envia ao remoto
git push

# Se quiser incorporar updates da main:
git fetch origin
git merge origin/main   # ou git rebase origin/main

# Ao terminar e estiver pronto para unir na main:
# (aqui você volta para main, mescla e envia)
git checkout main
git pull origin main
git merge minha-nova-branch
git push origin main -->

<template>
  <div>

    <!-- Diálogo para mostrar mensagem de sucesso após exclusão -->
    <v-dialog v-model="dialogSucesso" max-width="500">
      <v-card>
        <v-card-title class="text-h5">
          {{ mensagemSucesso }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="fecharSucesso">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Diálogo para visualizar a ordem completa e saldos por setor -->
    <v-dialog v-model="dialog" fullscreen persistent>
      <v-card>
        <!-- Cabeçalho com título e botão fechar -->

        <v-card-title class="bg-primary text-white d-flex align-center" min-height="150">

          <v-icon class="mr-2">mdi-clipboard-list-outline</v-icon>

          <v-chip    class="mr-2 mt-2 mb-2"
          style="padding: 10px;"
           variant="flat" large >
            <span
            class="mt-1 mb-1 text-h5 font-weight-medium black--text"
            style="padding: 10px;"

            >Ordem# {{ idOrdem }}</span>
          </v-chip>


          <v-chip color="white" size="small" class="mr-2" density="comfortable" variant="flat" large>
            <span class="mt-1 mb-1 text-h5 font-weight-medium black--text">Setor: {{
              setorAtualRecebidoPai?.descricao_setor || 'nenhum' }}</span>
          </v-chip>


          <!-- total de pecas -->
          <v-chip color="white" size="small" class="mr-2" density="comfortable" variant="flat" large>
            <span class="mt-1 mb-1 text-h5 font-weight-medium black--text">Total de Pecas: {{ totalPecas() || 0 }}</span>
          </v-chip>



          <v-spacer />
          <!-- criar botao de atualizar -->
          <v-btn icon @click="atualizarDialog" variant="text">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>

          <v-btn icon @click="fecharDialog" variant="text">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <!-- Indicador de loading geral -->
          <div v-if="carregando" class="d-flex justify-center align-center" style="height: 300px;">
            <v-progress-circular indeterminate color="primary" size="64" />
          </div>

          <div v-else>


            <!-- Tabela de Saldos por Setor -->


            <!-- Filtros -->
            <v-row class="mb-4" dense hide-default-footer>
              <v-col cols="12" sm="3">
                <v-autocomplete v-model="filtros.setor" :items="setoresDisponiveis" label="Filtrar por Setor." clearable
                  density="compact" hide-details></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete v-model="filtros.parte" :items="partesDisponiveis" label="Filtrar por Parte" clearable
                  density="compact" hide-details></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="2">
                <v-autocomplete v-model="filtros.tamanho" :items="tamanhosDisponiveis" label="Filtrar por Tamanho"
                  clearable density="compact" hide-details></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="2">
                <v-autocomplete v-model="filtros.status" :items="statusDisponiveis" label="Filtrar por Status" clearable
                  density="compact" hide-details></v-autocomplete>
              </v-col>
<!-- limpar filtros -->
 <v-col cols="12" sm="2">
                <v-btn color="primary" variant="outlined" @click="limparFiltros" class="mt-0 mb-2">
                  <v-icon start>mdi-filter-outline</v-icon>
                  Limpar Filtros
                </v-btn>
              </v-col>

            </v-row>

            <v-data-table
  v-model:items-per-page="itemsPerPage"
  :headers="headersSaldos"
  :items="filtrarSaldos"
  :loading="carregando"
  :search="search"
  :item-class="getRowClass"
  class="elevation-1"
  density="compact"
  fixed-header
  height="700"
  item-value="id_unico"
  items-per-page-text="Itens por página:"
  loading-text="Carregando..."
  no-data-text="Nenhum dado disponível"
  hide-default-footer
>

              <!-- tira o rodape -->
              <template v-slot:bottom></template>
              <!-- Coluna do Setor -->
              <template #item.nome_setor="{ item, isSelected, select }" @click="select(!isSelected)">
                <div class="d-flex align-center">
                  <v-icon :color="getCorSetor(item.nome_setor)" class="mr-2" size="small">
                    {{ getIconeSetor(item.nome_setor) }}
                  </v-icon>
                  <span :class="{ 'text-red': item.setor_finalizado_com_erro > 0 }">
                    <v-chip size="small" :color="getCorSetor(item.nome_setor)" variant="flat" density="comfortable"
                      class="font-weight-bold">
                      {{ item.nome_setor }}
                    </v-chip>
                  </span>
                </div>
              </template>

              <!-- Coluna do Funcionário -->
              <template #item.funcionario_atual_id="{ item }">
                <div class="text-center">
                  <v-chip size="small" :color="getCorSetor(item.nome_setor)" variant="flat" density="comfortable"
                    class="font-weight-bold">
                    {{ item.funcionario_atual_id }} - {{ (item.funcionario_atual_nome || '-').split(' ')[0] }}
                  </v-chip>
                </div>
              </template>

              <!-- Coluna de Ações -->
              <template #item.actions="{ item }">
                <v-btn icon small color="primary" @click.stop="abrirDetalhes(item)" title="Ver detalhes" variant="text"
                  density="comfortable">
                  <v-icon small>mdi-eye</v-icon>
                </v-btn> <!-- linha adicionada: botão para abrir diálogo de detalhes -->
              </template>

              <!-- Coluna 'Parte' -->
              <template #item.parte="{ item }">
                <div class="text-center">
                  <v-chip size="small" color="blue-darken-1" variant="flat" density="comfortable"
                    class="font-weight-bold">
                    {{ item.parte || '-' }}
                  </v-chip>
                </div>
              </template>

              <!-- Coluna 'Tamanho' -->
              <template #item.tamanho="{ item }">
                <div class="text-center">
                  <v-chip size="small" color="blue-grey-darken-1" variant="flat" density="comfortable"
                    class="font-weight-bold">
                    {{ item.tamanho || '-' }}
                  </v-chip>
                </div>
              </template>

              <!-- Colunas Numéricas -->
              <template #item.planejada_inicial="{ item }">
                <div class="text-center">
                  <v-chip size="small" :color="getChipColorForNumber(item.planejada_inicial)" density="comfortable"
                    class="font-weight-bold">
                    {{ formatarNumero(item.planejada_inicial) }}
                  </v-chip>
                </div>
              </template>

              <template #item.entradas="{ item }">
                <div class="text-center">
                  <v-chip size="small" color="blue-darken-1" density="comfortable" class="font-weight-bold">
                    {{ formatarNumero(item.entradas) }}
                  </v-chip>
                </div>
              </template>

              <template #item.saidas="{ item }">
                <div class="text-center">
                  <v-chip size="small" color="red-darken-1" density="comfortable" class="font-weight-bold">
                    {{ formatarNumero(item.saidas) }}
                  </v-chip>
                </div>
              </template>

              <template #item.planejada_final="{ item }">
                <div class="text-center">
                  <v-chip size="small" color="green-darken-1" density="comfortable" class="font-weight-bold">
                    {{ formatarNumero(item.planejada_final) }}
                  </v-chip>
                </div>
              </template>

              <template #item.recebida_qts="{ item }">
                <div class="text-center">
                  <v-chip size="small" :color="getChipColorForNumber(item.recebida_qts, 'blue')" density="comfortable"
                    class="font-weight-bold">
                    {{ formatarNumero(item.recebida_qts) }}
                  </v-chip>
                </div>
              </template>

              <template #item.recebida_aprovada="{ item }">
                <div class="text-center">
                  <v-chip size="small" :color="getChipColorForNumber(item.recebida_aprovada, 'green')"
                    density="comfortable" class="font-weight-bold">
                    {{ formatarNumero(item.recebida_aprovada) }}
                  </v-chip>
                </div>
              </template>

              <template #item.recebida_aguardando_aprovocao="{ item }">
                <div class="text-center">
                  <v-chip size="small" :color="getChipColorForNumber(item.recebida_aguardando_aprovocao, 'orange')"
                    density="comfortable" class="font-weight-bold">
                    {{ formatarNumero(item.recebida_aguardando_aprovocao) }}
                  </v-chip>
                </div>
              </template>

              <template #item.produzida="{ item }">
                <div class="text-center">
                  <v-chip size="small" :color="getChipColorForNumber(item.produzida, 'purple')" density="comfortable"
                    class="font-weight-bold">
                    {{ formatarNumero(item.produzida) }}
                  </v-chip>
                </div>
              </template>

              <template #item.transito="{ item }">
                <div class="text-center">
                  <v-chip size="small" :color="getChipColorForNumber(item.transito, 'cyan')" density="comfortable"
                    class="font-weight-bold">
                    {{ formatarNumero(item.transito) }}
                  </v-chip>
                </div>
              </template>

              <template #item.previsao_falta_a_ser_produzida="{ item }">
                <div class="text-center">
                  <v-chip size="small" :color="getChipColorForNumber(item.previsao_falta_a_ser_produzida, 'red')"
                    density="comfortable" class="font-weight-bold">
                    {{ formatarNumero(item.previsao_falta_a_ser_produzida) }}
                  </v-chip>
                </div>
              </template>

              <template #item.saldo_disponivel_produzir="{ item }">
                <div class="text-center">
                  <v-chip size="small" :color="getChipColorForNumber(item.saldo_disponivel_produzir, 'green')"
                    density="comfortable" class="font-weight-bold">
                    {{ formatarNumero(item.saldo_disponivel_produzir) }}
                  </v-chip>
                </div>
              </template>

              <!-- Coluna de Erros -->
              <template #item.setor_finalizado_com_erro="{ item }">
                <div class="text-center">
                  <v-chip v-if="item.setor_finalizado_com_erro > 0" small color="error" class="font-weight-bold"
                    density="comfortable">
                    {{ item.setor_finalizado_com_erro }}
                  </v-chip>
                  <span v-else class="text-caption">-</span>
                </div>
              </template>

              <!-- Colunas de Status -->
              <template #item.status_aprovacao_recebimento="{ item }">
                <div class="text-center">
                  <v-chip small :color="getChipColor(item.status_aprovacao_recebimento)" class="text-uppercase"
                    density="comfortable">
                    {{ formatarStatus(item.status_aprovacao_recebimento) }}
                  </v-chip>
                </div>
              </template>

              <template #item.status_aprovacao_enviadas="{ item }">
                <div class="text-center">
                  <v-chip small :color="getChipColor(item.status_aprovacao_enviadas)" class="text-uppercase"
                    density="comfortable">
                    {{ formatarStatus(item.status_aprovacao_enviadas) }}
                  </v-chip>
                </div>
              </template>

              <template #item.status_geral="{ item }">
                <div class="text-center">
                  <v-chip small :color="getGeralColor(item.status_geral)" class="text-uppercase" density="comfortable">
                    {{ formatarStatus(item.status_geral) }}
                  </v-chip>
                </div>
              </template>

              <!-- Mensagem quando não há dados -->
              <template #no-data>
                <v-alert type="info" class="ma-4" text="Nenhum dado disponível para exibição"
                  icon="mdi-information"></v-alert>
              </template>
            </v-data-table>



            <!-- Diálogo de Detalhes em Tela Cheia -->
            <v-dialog v-model="dialogDetalhes" fullscreen transition="dialog-bottom-transition" scrollable>
              <v-card>
                <v-toolbar dark color="primary">
                  <v-btn icon dark @click="dialogDetalhes = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>Detalhes da Linha</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="dialogDetalhes = false">
                      <v-icon left>mdi-close</v-icon> Fechar
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text v-if="linhaSelecionada" class="pa-0 dialog-content">
                  <v-tabs v-model="tab" color="primary" grow class="elevation-1">
                    <v-tab value="detalhes">
                      <v-icon start>mdi-card-text-outline</v-icon>
                      <span class="font-weight-medium">Detalhes</span>
                    </v-tab>
                    <v-tab value="movimentacoes">
                      <v-icon start>mdi-transfer</v-icon>
                      <span class="font-weight-medium">Movimentações</span>
                    </v-tab>
                  </v-tabs>

                  <v-window v-model="tab" class="window-content">
                    <v-window-item value="detalhes">
                      <v-container fluid class="pa-6">
                        <v-card class="elevation-2">
                          <v-card-text class="pa-6">
                            <!-- <v-row dense class="mb-1">
                              <v-col cols="12" class="text-center mb-4">
                                <v-icon size="40" color="primary" class="mb-2">mdi-information-outline</v-icon>
                                <div class="text-h6 primary--text font-weight-bold">Detalhes do Item</div>
                              </v-col>
                            </v-row> -->

                            <v-row dense class="detail-container">
                              <v-col cols="12">
                                <v-card variant="flat" class="detail-card">
                                  <v-card-text class="pa-0">
                                    <template v-for="(value, key, index) in linhaSelecionada" :key="key">
                                      <v-row v-if="key !== 'movimentacoes'" no-gutters align="center"
                                        class="detail-row pa-3" :class="{ 'lighten-5': index % 2 === 0 }">
                                        <v-col cols="12" md="4" class="py-2">
                                          <span class="text-subtitle-1 font-weight-medium primary--text">
                                            {{ formatarChave(key) }}
                                          </span>
                                        </v-col>
                                        <v-col cols="12" md="8" class="py-2">
                                          <div class="d-flex align-center">
                                            <template v-if="typeof value === 'number' && value !== null">
                                              <v-chip :color="getChipColorForNumber(value)" size="small"
                                                class="font-weight-bold text-body-1">
                                                {{ formatarNumero(value) }}
                                              </v-chip>
                                            </template>
                                            <template
                                              v-else-if="['status_geral', 'status_aprovacao_recebimento', 'status_aprovacao_enviadas'].includes(key)">
                                              <v-chip :color="getChipColor(value)" size="small"
                                                class="text-uppercase font-weight-bold text-body-1">
                                                {{ formatarStatus(value) }}
                                              </v-chip>
                                            </template>
                                            <template v-else>
                                              <span class="text-body-1" :class="{ 'grey--text': !value }">
                                                {{ value || 'Não informado' }}
                                              </span>
                                            </template>
                                          </div>
                                        </v-col>
                                      </v-row>
                                      <v-divider v-if="index < Object.keys(linhaSelecionada).length - 1"></v-divider>
                                    </template>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>

                            <!-- ✅ SEÇÃO DE OBSERVAÇÕES MELHORADA -->
                            <v-row v-if="linhaSelecionada?.movimentacoes && linhaSelecionada.movimentacoes.filter(m => m.observacao && m.observacao.trim() !== '' && m.observacao !== 'Movimentação automática abertura').length > 0" dense class="mt-4">
                              <v-col cols="12">
                                <v-card class="elevation-3">
                                  <v-card-title class="bg-gradient-primary text-white d-flex align-center pa-4" style="background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);">
                                    <v-icon color="white" size="large" class="mr-3">mdi-comment-text-multiple</v-icon>
                                    <span class="text-h6 font-weight-bold">Observações da Ordem</span>
                                    <v-spacer></v-spacer>
                                    <v-chip 
                                      color="white" 
                                      text-color="primary"
                                      size="small" 
                                      class="font-weight-bold">
                                      {{ linhaSelecionada.movimentacoes.filter(m => m.observacao && m.observacao.trim() !== '' && m.observacao !== 'Movimentação automática abertura').length }} observação(ões)
                                    </v-chip>
                                  </v-card-title>
                                  <v-card-text class="pa-4" style="max-height: 500px; overflow-y: auto; background-color: #fafafa;">
                                    <v-timeline density="compact" side="end" align="start">
                                      <v-timeline-item 
                                        v-for="(mov, idx) in linhaSelecionada.movimentacoes.filter(m => m.observacao && m.observacao.trim() !== '' && m.observacao !== 'Movimentação automática abertura')" 
                                        :key="mov.id || idx"
                                        :dot-color="mov.origem === mov.destino ? 'orange' : 'primary'"
                                        size="small">
                                        <template v-slot:icon>
                                          <v-icon color="white" size="small">{{ mov.origem === mov.destino ? 'mdi-note-text' : 'mdi-transfer' }}</v-icon>
                                        </template>
                                        
                                        <v-card class="elevation-2 mb-3">
                                          <v-card-text class="pa-3">
                                            <!-- Cabeçalho com origem/destino -->
                                            <div class="d-flex align-center mb-2 flex-wrap" style="gap: 8px;">
                                              <v-chip size="small" color="blue" variant="flat" class="font-weight-medium">
                                                {{ mov.origem }}
                                              </v-chip>
                                              <template v-if="mov.destino && mov.origem !== mov.destino">
                                                <v-icon size="small">mdi-arrow-right</v-icon>
                                                <v-chip size="small" color="green" variant="flat" class="font-weight-medium">
                                                  {{ mov.destino }}
                                                </v-chip>
                                              </template>
                                              <v-chip v-else size="small" color="orange" variant="tonal">
                                                Observação Simples
                                              </v-chip>
                                            </div>

                                            <!-- Metadados -->
                                            <div class="text-caption text-grey-darken-1 mb-3 d-flex flex-wrap" style="gap: 12px;">
                                              <span><v-icon size="x-small" class="mr-1">mdi-calendar</v-icon>{{ formatarData(mov.data) }}</span>
                                              <span v-if="mov.quantidade > 0"><v-icon size="x-small" class="mr-1">mdi-package-variant</v-icon>{{ mov.quantidade }} un.</span>
                                              <span v-if="mov.parte"><v-icon size="x-small" class="mr-1">mdi-puzzle</v-icon>{{ mov.parte }}</span>
                                              <span v-if="mov.tamanho && mov.tamanho !== '0'"><v-icon size="x-small" class="mr-1">mdi-ruler</v-icon>Tam. {{ mov.tamanho }}</span>
                                            </div>

                                            <!-- Observação -->
                                            <div class="observacao-texto pa-3" style="background-color: #fff; border-left: 4px solid #1976d2; border-radius: 4px;">
                                              <div style="white-space: pre-line; word-wrap: break-word; line-height: 1.6; font-size: 14px; color: #424242;">
                                                {{ mov.observacao }}
                                              </div>
                                            </div>
                                          </v-card-text>
                                        </v-card>
                                      </v-timeline-item>
                                    </v-timeline>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-container>
                    </v-window-item>

                    <v-window-item value="movimentacoes">
                      <v-container fluid class="pa-4">
                        <v-card variant="outlined">
                          <v-card-title class="d-flex align-center pa-4">
                            <v-icon color="primary" class="mr-2">mdi-transfer</v-icon>
                            <span class="text-h6">Histórico de Movimentações</span>
                            <v-spacer></v-spacer>
                            <v-chip color="primary" size="small" class="font-weight-medium">
                              {{ linhaSelecionada?.movimentacoes?.length || 0 }} movimentações
                            </v-chip>
                          </v-card-title>

                          <v-divider></v-divider>

                          <v-card-text class="pa-0">
                            <v-data-table :headers="[

                              { title: 'Data', key: 'data', align: 'start', width: '200' },
                              { title: 'Ações', key: 'acoes', align: 'center', width: '100' },
                              { title: 'Id.Lanc.', key: 'id', align: 'start', width: '200' },
                              { title: 'Origem', key: 'origem', align: 'start', width: '200' },
                              { title: 'Destino', key: 'destino', align: 'start', width: '200' },
                              { title: 'Parte', key: 'parte', align: 'start', width: '100' },
                              { title: 'Tamanho', key: 'tamanho', align: 'start', width: '100' },
                              { title: 'Quantidade', key: 'quantidade', align: 'center', width: '120' },
                              { title: 'Observação', key: 'observacao', align: 'start' },
                              { title: 'Data Autorização', key: 'data_autoricacao', align: 'center', width: '120' },
                              { title: 'Chefe Autorizou', key: 'id_chefe_autorizou', align: 'center', width: '120' },
                              { title: 'Chefe Cadastro', key: 'id_chefe_cadastro', align: 'center', width: '120' },
                            ]" :items="linhaSelecionada?.movimentacoes || []" class="elevation-0"
                              density="comfortable">
                              <!-- Data -->
                              <template #item.data="{ item }">
                                <div class="d-flex align-center">
                                  <v-icon size="small" color="grey" class="mr-2">mdi-calendar-clock</v-icon>
                                  {{ formatarData(item.data) }}
                                </div>
                              </template>

                              <!-- Id Lançamento -->
                              <template #item.id="{ item }">
                                <v-chip size="small" color="grey-lighten-1" variant="tonal">
                                  #{{ item.id }}
                                </v-chip>
                              </template>

                              <!-- Origem -->
                              <template #item.origem="{ item }">
                                <v-chip size="small" :color="getCorSetor(item.origem)" variant="flat"
                                  class="font-weight-medium">
                                  <v-icon size="small" start>{{ getIconeSetor(item.origem) }}</v-icon>
                                  {{ item.origem }}
                                </v-chip>
                              </template>

                              <!-- Destino -->
                              <template #item.destino="{ item }">
                                <v-chip size="small" :color="getCorSetor(item.destino)" variant="flat"
                                  class="font-weight-medium">
                                  <v-icon size="small" start>{{ getIconeSetor(item.destino) }}</v-icon>
                                  {{ item.destino }}
                                </v-chip>
                              </template>

                              <!-- Parte -->
                              <template #item.parte="{ item }">
                                <v-chip size="small" :color="getCorSetor(item.parte)" class="font-weight-medium">
                                  {{ item.parte }}
                                </v-chip>
                              </template>

                              <!-- Tamanho -->
                              <template #item.tamanho="{ item }">
                                <v-chip size="small" color="blue-grey-darken-1" variant="flat" density="comfortable"
                                  class="font-weight-medium">
                                  {{ item.tamanho }}
                                </v-chip>
                              </template>

                              <!-- Quantidade -->
                              <template #item.quantidade="{ item }">
                                <v-chip size="small" :color="getChipColorForNumber(item.quantidade)"
                                  class="font-weight-medium">
                                  {{ formatarNumero(item.quantidade) }}
                                </v-chip>
                              </template>

                              <!-- Observação -->
                              <template #item.observacao="{ item }">
                                <div class="text-truncate" style="max-width: 200px;">
                                  <v-tooltip location="top" v-if="item.observacao">
                                    <template v-slot:activator="{ props }">
                                      <span v-bind="props" class="text-caption">
                                        {{ item.observacao }}
                                      </span>
                                    </template>
                                    <span>{{ item.observacao }}</span>
                                  </v-tooltip>
                                  <span v-else class="text-caption text-grey">-</span>
                                </div>
                              </template>

                              <!-- Data Autorização -->
                              <template #item.data_autoricacao="{ item }">
                                <div v-if="item.data_autoricacao && item.data_autoricacao !== 'N/A'">
                                  <v-chip size="small" color="success" variant="tonal">
                                    <v-icon size="small" start>mdi-check-circle</v-icon>
                                    {{ formatarData(item.data_autoricacao) }}
                                  </v-chip>
                                </div>
                                <v-chip v-else size="small" color="warning" variant="tonal">
                                  <v-icon size="small" start>mdi-clock-alert</v-icon>
                                  Pendente
                                </v-chip>
                              </template>

                              <!-- Chefe Autorizou -->
                              <template #item.id_chefe_autorizou="{ item }">
                                <div v-if="item.id_chefe_autorizou && item.id_chefe_autorizou !== 'N/A' && item.id_chefe_autorizou !== 0">
                                  <v-chip size="small" color="blue" variant="tonal">
                                    <v-icon size="small" start>mdi-account-check</v-icon>
                                    {{ item.id_chefe_autorizou }}
                                  </v-chip>
                                </div>
                                <span v-else class="text-caption text-grey">-</span>
                              </template>

                              <!-- Chefe Cadastro -->
                              <template #item.id_chefe_cadastro="{ item }">
                                <div v-if="item.id_chefe_cadastro && item.id_chefe_cadastro !== 'N/A' && item.id_chefe_cadastro !== 0">
                                  <v-chip size="small" color="purple" variant="tonal">
                                    <v-icon size="small" start>mdi-account-edit</v-icon>
                                    {{ item.id_chefe_cadastro }}
                                  </v-chip>
                                </div>
                                <span v-else class="text-caption text-grey">-</span>
                              </template>

                              <!-- Coluna de Ações  gato-->
                              <template #item.acoes="{ item }">
                                <v-btn icon="mdi-delete" color="error" size="small" variant="text"
                                :disabled="item.data_autoricacao &&
               item.data_autoricacao !== 'N/A' &&
               item.data_autoricacao !== null &&
               item.data_autoricacao !== undefined"


                                   @click="confirmarRemoverMovimentacao(item)"
                                  >





                                </v-btn>

                              </template>
                            </v-data-table>
                          </v-card-text>
                        </v-card>
                      </v-container>
                    </v-window-item>
                  </v-window>
                </v-card-text>
              </v-card>
            </v-dialog>



          </div>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn color="grey" variant="outlined" @click="fecharDialog" prepend-icon="mdi-arrow-left">
            Voltar para Lista
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de confirmação para remover movimentação -->
    <v-dialog v-model="dialogConfirmacao" max-width="500">
      <v-card>
        <v-card-title class="text-h5 pa-4">
          <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
          Confirmar Exclusão
        </v-card-title>

        <v-card-text class="pa-4">
          <p>Tem certeza que deseja remover esta movimentação ?</p>
          <p class="text-caption text-grey mt-2">Esta ação não pode ser desfeita.</p>

          <v-alert v-if="itemSelecionado" color="info" variant="tonal" class="mt-4">
            <div><strong>Data:</strong> {{ formatarData(itemSelecionado.data) }}</div>
            <div><strong>Tamanho:</strong> {{ itemSelecionado.tamanho }}</div>
            <div><strong>Quantidade:</strong> {{ itemSelecionado.quantidade }}</div>
            <div><strong>Origem:</strong> {{ itemSelecionado.origem }}</div>
            <div><strong>Destino:</strong> {{ itemSelecionado.destino }}</div>
          </v-alert>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="dialogConfirmacao = false" :disabled="processando">
            Cancelar
          </v-btn>
          <v-btn color="error" variant="flat" @click="removerMovimentacao(itemSelecionado)" :loading="processando"
            :disabled="processando">
            Remover
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { producaoService } from '@/services/producaoService';
import { useUserStore } from "@/store/userStore";
import { useToast } from 'vue-toastification';

const toast = useToast();
// Removido: const userStore = useUserStore();
// O userStore será inicializado dentro do componente para evitar erros

export default {
  name: "VisualizarOrdemCompleta",

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    idOrdem: {
      type: [String, Number],
      default: 0
    },
    setorAtualRecebidoPai: {
      type: [String, Number, Object],
      default: null
    }
  },

  data() {
    return {
      // Inicialização do userStore dentro do componente
      userStore: useUserStore(),
      dialogSucesso: false,
      mensagemSucesso: '',
      tab: 'detalhes',                     // Controla a aba ativa no diálogo
      dialogDetalhes: false,           // Controla abertura do diálogo de detalhes
      linhaSelecionada: null,          // Armazena o item selecionado para detalhes
      itemsPerPage: -1,
      search: '',
      processando: false,              // Indica se está processando uma operação
      dialogConfirmacao: false,        // Controla o diálogo de confirmação de exclusão
      movimentacaoParaRemover: null,   // Armazena a movimentação que será removida
      // Filtros
      filtros: {
        setor: null,
        parte: null,
        tamanho: null,
        status: null
      },
      dialog: this.modelValue || false,
      carregando: true,

      idOrdemProducao: this.idOrdem,
      ordemInfo: {},
      saldos: [],

      // Cabeçalhos para a tabela de saldos por setor
      headersSaldos: [
        {
          title: 'Setor',
          key: 'nome_setor',
          align: 'start',
          width: '15%',
          sortable: true,
          value: 'nome_setor'
        },


        {
          title: 'Ações',                 // linha adicionada: coluna de ações
          key: 'actions',                 // linha adicionada
          sortable: false,               // linha adicionada
          width: '5%',                   // linha adicionada
          align: 'center'                // linha adicionada
        },
        {
          title: 'Parte',
          key: 'parte',
          align: 'center',
          width: '8%',
          sortable: true,
          value: 'parte'
        },
        {
          title: 'Tamanho',
          key: 'tamanho',
          align: 'center',
          width: '8%',
          sortable: true,
          value: 'tamanho'
        },
        {
          title: 'Inicial',
          key: 'planejada_inicial',
          align: 'center',
          width: '8%',
          sortable: true,
          value: 'planejada_inicial'
        },
        {
          title: 'Erros',
          key: 'setor_finalizado_com_erro',
          align: 'center',
          width: '8%',
          sortable: true,
          value: 'setor_finalizado_com_erro',
          class: 'font-weight-bold error--text'
        },
        {
          title: 'Final',
          key: 'planejada_final',
          align: 'center',
          width: '8%',
          sortable: true,
          value: 'planejada_final'
        },
        {
          title: 'Recebimento',
          key: 'entradas',
          align: 'center',
          width: '8%',
          sortable: true,
          value: 'entradas'
        },
        {
          title: 'Pendente Aprovação',
          key: 'recebida_aguardando_aprovocao',
          align: 'center',
          width: '8%',
          sortable: true,
          value: 'recebida_aguardando_aprovocao'
        },
        {
          title: 'Saídas',
          key: 'saidas',
          align: 'center',
          width: '8%',
          sortable: true,
          value: 'saidas'
        },
        {
          title: 'Produzida',
          key: 'produzida',
          align: 'center',
          width: '8%',
          sortable: true,
          value: 'produzida'
        },
        {
          title: 'Em Trânsito',
          key: 'transito',
          align: 'center',
          width: '8%',
          sortable: true,
          value: 'transito'
        },
        {
          title: 'Disponível Produção',
          key: 'saldo_disponivel_produzir',
          align: 'center',
          width: '8%',
          sortable: true,
          value: 'saldo_disponivel_produzir'
        },
        {
          title: 'Previsão de Falta',
          key: 'previsao_falta_a_ser_produzida',
          align: 'center',
          width: '8%',
          sortable: true,
          value: 'previsao_falta_a_ser_produzida'
        },
        {
          title: 'Recebimento',
          key: 'status_aprovacao_recebimento',
          align: 'center',
          width: '10%',
          sortable: true,
          value: 'status_aprovacao_recebimento'
        },
        {
          title: 'Envios',
          key: 'status_aprovacao_enviadas',
          align: 'center',
          width: '10%',
          sortable: true,
          value: 'status_aprovacao_enviadas'
        },
        {
          title: 'Status',
          key: 'status_geral',
          align: 'center',
          width: '10%',
          sortable: true,
          value: 'status_geral'
        },
        {
          title: 'Funcionário',
          key: 'funcionario_atual_id',
          align: 'start',
          width: '15%',
          sortable: true,
          value: 'funcionario_atual'
        },
      ]
    };
  },

  watch: {

      // ✅ WATCHER PARA DEBUG DOS FILTROS
  filtros: {
    handler(newVal, oldVal) {
      console.log('🔄 Filtros alterados:', {
        anterior: oldVal,
        novo: newVal,
        resultados: this.filtrarSaldos.length
      });
    },
    deep: true
  },

    modelValue(val) {
      this.dialog = val;
      if (val) this.carregarDados();
    },
    dialog(val) {
      this.$emit('update:modelValue', val);
    },
    idOrdem() {
      if (this.dialog) this.carregarDados();
    },

      // ✅ WATCHER PARA SALDOS
  saldos: {
    handler(newVal) {
      if (newVal && newVal.length > 0) {
        const duplicatas = newVal.length - this.removerDuplicatasSaldos().length;
        if (duplicatas > 0) {
          console.warn(`⚠️ Detectadas ${duplicatas} duplicatas nos saldos`);
        }
      }
    },
    immediate: true
  }

  },

  created() {


    if (this.dialog) this.carregarDados();
  },

  computed: {
    // usuario logado
    ObjUsuario() {
      return this.userStore.objetoUsuario || "Sem Usuário";
    },
    // Filtra os saldos com base nos filtros selecionados
    // ✅ FILTRO CORRIGIDO SEM DUPLICAÇÃO
   // ✅ FILTRO CORRIGIDO COM ID ÚNICO
   filtrarSaldos() {
    if (!this.saldos || this.saldos.length === 0) {
      return [];
    }

    // ✅ PRIMEIRO: Remover duplicatas e adicionar ID único
    const saldosUnicos = [];
    const idsProcessados = new Set();

    this.saldos.forEach((item, index) => {
      // Criar ID único mais robusto
      const idUnico = item.id ||
        `${item.nome_setor || 'sem_setor'}_${item.parte || 'sem_parte'}_${item.tamanho || 'sem_tamanho'}_${item.funcionario_atual_id || 'sem_funcionario'}_${index}`;

      if (!idsProcessados.has(idUnico)) {
        idsProcessados.add(idUnico);

        // ✅ ADICIONAR ID ÚNICO AO ITEM
        const itemComId = {
          ...item,
          id_unico: idUnico  // Campo único para o VDataTable
        };

        saldosUnicos.push(itemComId);
      }
    });

    console.log(`🧹 Saldos: ${this.saldos.length} → ${saldosUnicos.length} (${this.saldos.length - saldosUnicos.length} duplicatas removidas)`);

    // ✅ SEGUNDO: Aplicar filtros nos dados únicos
    const filtrados = saldosUnicos.filter(item => {
      // Filtro por Setor
      const setorMatch = !this.filtros.setor ||
        (item.nome_setor || '').toString().toUpperCase().trim() === this.filtros.setor.toString().toUpperCase().trim();

      // Filtro por Parte
      const parteMatch = !this.filtros.parte ||
        (item.parte || '').toString().toUpperCase().trim().includes(this.filtros.parte.toString().toUpperCase().trim());

      // Filtro por Tamanho
      const tamanhoMatch = !this.filtros.tamanho ||
        (item.tamanho || '').toString().toUpperCase().trim() === this.filtros.tamanho.toString().toUpperCase().trim();

      // Filtro por Status
      const statusMatch = !this.filtros.status ||
        (item.status_geral || '').toString().toUpperCase().trim() === this.filtros.status.toString().toUpperCase().trim();

      return setorMatch && parteMatch && tamanhoMatch && statusMatch;
    });

    console.log(`�� Filtros aplicados: ${saldosUnicos.length} → ${filtrados.length} itens`);

    // ✅ VERIFICAR SE HÁ IDs ÚNICOS DUPLICADOS (DEBUG)
    const idsUnicos = filtrados.map(item => item.id_unico);
    const idsDuplicados = idsUnicos.filter((id, index) => idsUnicos.indexOf(id) !== index);

    if (idsDuplicados.length > 0) {
      console.error('❌ IDs únicos duplicados encontrados:', idsDuplicados);
    }

    return filtrados;
  },


   // ✅ SETORES ÚNICOS (CORRIGIDO)
   setoresDisponiveis() {
    const setores = new Set();

    // Usar saldos únicos em vez de this.saldos diretamente
    const saldosUnicos = this.removerDuplicatasSaldos();

    saldosUnicos.forEach(item => {
      if (item.nome_setor && item.nome_setor.trim()) {
        setores.add(item.nome_setor.trim());
      }
    });

    return Array.from(setores).sort();
  },

  // ✅ PARTES ÚNICAS (CORRIGIDO)
  partesDisponiveis() {
    const partes = new Set();

    const saldosUnicos = this.removerDuplicatasSaldos();

    saldosUnicos.forEach(item => {
      if (item.parte && item.parte.trim()) {
        partes.add(item.parte.trim());
      }
    });

    return Array.from(partes).sort();
  },


    // Gera lista de partes únicas para o filtro
    partesDisponiveis() {
      const partes = new Set();
      this.saldos.forEach(item => {
        if (item.parte) partes.add(item.parte);
      });
      return Array.from(partes).sort();
    },

    // ✅ TAMANHOS ÚNICOS (CORRIGIDO)
    tamanhosDisponiveis() {
    const tamanhos = new Set();

    const saldosUnicos = this.removerDuplicatasSaldos();

    saldosUnicos.forEach(item => {
      if (item.tamanho && item.tamanho.trim()) {
        tamanhos.add(item.tamanho.trim());
      }
    });

    return Array.from(tamanhos).sort();
  },


     // ✅ STATUS ÚNICOS (CORRIGIDO)
  statusDisponiveis() {
    const status = new Set();

    const saldosUnicos = this.removerDuplicatasSaldos();

    saldosUnicos.forEach(item => {
      if (item.status_geral && item.status_geral.trim()) {
        status.add(item.status_geral.trim());
      }
    });

    return Array.from(status).sort();
  }
},


  methods: {
      // ✅ MÉTODO AUXILIAR PARA REMOVER DUPLICATAS
  removerDuplicatasSaldos() {
    if (!this.saldos || this.saldos.length === 0) {
      return [];
    }

    const saldosUnicos = [];
    const idsProcessados = new Set();

    this.saldos.forEach(item => {
      // Criar ID único mais robusto
      const idUnico = item.id ||
        `${item.nome_setor || 'sem_setor'}_${item.parte || 'sem_parte'}_${item.tamanho || 'sem_tamanho'}_${item.funcionario_atual_id || 'sem_funcionario'}_${item.planejada_inicial || 0}`;

      if (!idsProcessados.has(idUnico)) {
        idsProcessados.add(idUnico);
        saldosUnicos.push(item);
      }
    });

    return saldosUnicos;
  },


    // ✅ MÉTODO PARA DEBUG DOS FILTROS
    debugFiltros() {
    console.log('�� Estado dos filtros:', {
      setor: this.filtros.setor,
      parte: this.filtros.parte,
      tamanho: this.filtros.tamanho,
      status: this.filtros.status,
      totalSaldos: this.saldos.length,
      saldosUnicos: this.removerDuplicatasSaldos().length,
      saldosFiltrados: this.filtrarSaldos.length
    });
  },

  // ✅ MÉTODO PARA LIMPAR FILTROS (MELHORADO)
  limparFiltros() {
    this.filtros = {
      setor: null,
      parte: null,
      tamanho: null,
      status: null
    };

    console.log('🗑️ Filtros limpos');
  },

    totalPecas() {
      if (!this.ordemInfo) return 0;
      return this.ordemInfo?.quantidade_planejada || 0;
    },
    fecharSucesso() {
      this.dialogSucesso = false;
      this.carregarDados();
    },


    removerMovimentacao(item) {

      this.processando = true;

      // temos que chamar  serviço para remover a movimentação
      producaoService.removerMovimentacao(item.id)
        .then(response => {
          if (response.status == 'sucesso') {
            this.dialogSucesso = true;
            this.mensagemSucesso = response.mensagem;
            this.$toast.success(response.mensagem);
          } else {
            this.$toast.error(response.mensagem);
          }
        })
        .catch(error => {
          this.$toast.error(`Erro ao remover movimenta o: ${error}`);
        })
        .finally(() => {

          this.processando = false;
          this.dialogDetalhes = false;
          this.dialogConfirmacao = false; // Fecha o diálogo de confirmação
          this.itemSelecionado = null; // Limpa o item selecionado
          this.atualizarDialog();


        });
    },

    confirmarRemoverMovimentacao(item) {
      this.itemSelecionado = item;
      this.dialogConfirmacao = true;
    },
    atualizarDialog() {
      this.carregando = true;
      this.carregarDados();
    },
    abrirDetalhes(linha) {
      // ✅ Copiar a linha selecionada (mantém movimentações filtradas do setor)
      this.linhaSelecionada = { ...linha };
      
      // ✅ BUSCAR APENAS OBSERVAÇÕES LIVRES (origem=destino ou tamanho=0) de OUTROS saldos
      const observacoesLivres = [];
      this.saldos.forEach(saldo => {
        if (saldo.movimentacoes && Array.isArray(saldo.movimentacoes)) {
          // Filtrar apenas observações livres (observação simples)
          const obsLivres = saldo.movimentacoes.filter(mov => 
            mov.origem === mov.destino || 
            mov.tamanho === '0' || 
            mov.tamanho === 0
          );
          observacoesLivres.push(...obsLivres);
        }
      });
      
      // ✅ Remover duplicatas das observações livres
      const observacoesUnicas = observacoesLivres.reduce((acc, mov) => {
        if (!acc.find(m => m.id === mov.id)) {
          acc.push(mov);
        }
        return acc;
      }, []);
      
      // ✅ ADICIONAR observações livres às movimentações originais (sem substituir)
      const movimentacoesOriginais = this.linhaSelecionada.movimentacoes || [];
      const idsOriginais = movimentacoesOriginais.map(m => m.id);
      
      // Adicionar apenas observações que não estão nas movimentações originais
      const novasObservacoes = observacoesUnicas.filter(obs => !idsOriginais.includes(obs.id));
      
      this.linhaSelecionada.movimentacoes = [...movimentacoesOriginais, ...novasObservacoes];
      
      console.log('📊 Detalhes abertos:', {
        linha: linha.nome_setor,
        movimentacoesOriginais: movimentacoesOriginais.length,
        observacoesLivresAdicionadas: novasObservacoes.length,
        totalFinal: this.linhaSelecionada.movimentacoes.length
      });
      
      this.dialogDetalhes = true;
    },

    formatarChave(chave) {
      // Converte snake_case para Frase com Espaços
      return chave
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },

    getIconeSetor(nomeSetor) {
      if (!nomeSetor) return 'mdi-factory';
      const setor = nomeSetor.toString().toUpperCase().trim();
      const icones = {
        'CORTE': 'mdi-scissors-cutting',
        'COSTURA': 'mdi-needle',
        'ESTAMPARIA': 'mdi-spray',
        'LAVANDERIA': 'mdi-washing-machine',
        'ACABAMENTO': 'mdi-iron',
        'EMBALAGEM': 'mdi-package-variant',
        'EXPEDIÇÃO': 'mdi-truck-delivery',
        'EXPEDICAO': 'mdi-truck-delivery',
        'QUALIDADE': 'mdi-clipboard-check',
        'ESTOQUE': 'mdi-warehouse',
        'RECEPÇÃO': 'mdi-clipboard-text',
        'RECEPCAO': 'mdi-clipboard-text',
        'PRODUÇÃO': 'mdi-factory',
        'PRODUCAO': 'mdi-factory',
        'CONFERÊNCIA': 'mdi-clipboard-list',
        'CONFERENCIA': 'mdi-clipboard-list',
        'FINALIZAÇÃO': 'mdi-check-all',
        'FINALIZACAO': 'mdi-check-all',
        'SEPARAÇÃO': 'mdi-package-variant-closed',
        'SEPARACAO': 'mdi-package-variant-closed',
        'LOGÍSTICA': 'mdi-truck-cargo-container',
        'LOGISTICA': 'mdi-truck-cargo-container',
        'RISCO': 'mdi-draw',
        'BORDADO': 'mdi-needle',
        'BORDADOS': 'mdi-needle',
        'BORDAR': 'mdi-needle',
        'BORDADORIA': 'mdi-needle',
        'BORDADOR': 'mdi-needle',
        'RECUPERAÇÃO': 'mdi-backup-restore',
        'RECUPERACAO': 'mdi-backup-restore',
        'ENTREGUE': 'mdi-check-circle',
        'PCP': 'mdi-clipboard-flow',
        'FINALIZADO ERRO': 'mdi-alert-circle',  // inclui mapeamento para FINALIZADO ERRO
        'FINALIZADO': 'mdi-flag-checkered',
        'finalizado erro': 'mdi-alert-circle',
        'finalizado com erro': 'mdi-alert-circle',
        'erro': 'mdi-alert-circle',
        'finalizado': 'mdi-flag-checkered',
        // Setores adicionais
        'almoxarifado': 'mdi-package-variant-closed',
        'manutenção': 'mdi-tools',
        'manutencao': 'mdi-tools',
        'administrativo': 'mdi-desktop-mac-dashboard',
        'compras': 'mdi-cart',
        'vendas': 'mdi-currency-usd',
        'financeiro': 'mdi-cash-multiple',
        'rh': 'mdi-account-group',
        'ti': 'mdi-desktop-classic',
        'jurídico': 'mdi-scale-balance',
        'juridico': 'mdi-scale-balance',
        'comercial': 'mdi-handshake',
        'marketing': 'mdi-bullhorn',
        'engenharia': 'mdi-engine',
        'projetos': 'mdi-file-document-multiple',
        'planejamento': 'mdi-chart-gantt',
        'qualidade': 'mdi-clipboard-check',
        'segurança': 'mdi-shield-account',
        'seguranca': 'mdi-shield-account'
      };

      if (icones[setor]) return icones[setor];

      const setorNormalizado = setor.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().trim();
      if (icones[setorNormalizado]) return icones[setorNormalizado];

      for (const [palavra, icone] of Object.entries(icones)) {
        if (setor.includes(palavra) && palavra.length > 2) {
          return icone;
        }
      }

      const palavrasChave = {
        'BORD': 'mdi-needle',
        'COST': 'mdi-needle',
        'CORT': 'mdi-scissors-cutting',
        'LAV': 'mdi-washing-machine',
        'ACAB': 'mdi-iron',
        'EMBAL': 'mdi-package-variant',
        'EXPED': 'mdi-truck-delivery',
        'QUALI': 'mdi-clipboard-check',
        'ESTOQ': 'mdi-warehouse',
        'RECEP': 'mdi-clipboard-text',
        'PROD': 'mdi-factory',
        'CONF': 'mdi-clipboard-list',
        'FINAL': 'mdi-check-all',
        'SEPAR': 'mdi-package-variant-closed',
        'LOG': 'mdi-truck-cargo-container',
        'RIS': 'mdi-draw',
        'PCP': 'mdi-clipboard-flow'
      };

      for (const [chave, icone] of Object.entries(palavrasChave)) {
        if (setor.includes(chave)) return icone;
      }

      return 'mdi-factory';
    },

    getRowClass(item) {
      if (!item) return '';

      // linha adicionada: se nome_setor for 'FINALIZADO ERRO', aplica fundo vermelho
      if (
        item.nome_setor &&
        item.nome_setor.toString().toUpperCase().trim() === 'FINALIZADO ERRO'
      ) {
        return 'row-erro'; // linha adicionada
      }

      const statusRecebimento = item.status_aprovacao_recebimento?.toString().toLowerCase() || '';
      const statusEnviadas = item.status_aprovacao_enviadas?.toString().toLowerCase() || '';
      const statusGeral = item.status_geral?.toString().toLowerCase() || '';

      // Verifica se status geral é 'FINALIZADO'
      if (statusGeral.toUpperCase() === 'FINALIZADO') {
        return 'row-concluida';
      }

      // Verifica se todos os status estão concluídos/aprovados
      const todosConcluidos = [
        statusRecebimento,
        statusEnviadas,
        statusGeral
      ].every(status => ['concluído', 'aprovado', 'finalizado', 'ok'].includes(status));

      // Verifica se há erro em algum status
      const temErro = [
        statusRecebimento,
        statusEnviadas,
        statusGeral
      ].some(status => status && (status.includes('erro') || status.includes('rejeitado') || status.includes('reprovado')));

      if (temErro) return 'row-erro';
      if (todosConcluidos) return 'row-concluida';

      const statusGeralNormalizado = statusGeral.trim();
      if (
        statusGeralNormalizado.includes('finalizado') ||
        statusGeralNormalizado === 'finalizado' ||
        statusGeralNormalizado === 'finalizada'
      ) {
        return 'row-concluida';
      }

      return '';
    },

    // Retorna a cor do setor baseado no nome
    getCorSetor(nomeSetor) {
      if (nomeSetor?.toLowerCase().includes('finalizado erro')) return '#FF5252';
      if (nomeSetor?.toLowerCase().includes('entregue')) return '#2ECC40';
      if (nomeSetor?.toLowerCase().includes('recuperacao')) return '#F7DC6F';
      const colors = [
        '#2196F3', '#4CAF50', '#FF9800', '#9C27B0', '#F44336', '#00BCD4',
        '#8BC34A', '#FFC107', '#795548', '#607D8B', '#666666', '#9E9E9E',
        '#64B5F6', '#76D275', '#E0E0E0', '#424242', '#8E24AA',
        '#689F38', '#00ACC1', '#5C6BC0', '#64B5F6'
      ];
      const index = Math.abs(this.hashCode(nomeSetor) % colors.length);
      return colors[index];
    },

    // Função auxiliar para gerar hash de uma string
    hashCode(str) {
      let hash = 0;
      if (!str) return hash;
      for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
      }
      return hash;
    },

    // Carrega dados da ordem e saldos
    async carregarDados() {
      if (!this.idOrdem) {
        this.carregando = false;
        return;
      }

      this.carregando = true;
      this.ordemInfo = {};
      this.saldos = [];
      this.dadosPorSetor = {}; // Inicializa os dados por setor

      try {
        const response = await producaoService.buscarProducaoPorIdOrdem(this.idOrdem);
        if (!response || response.status !== 'sucesso' || !response.data) {
          throw new Error(response?.mensagem || 'Dados inválidos retornados da API');
        }

        const responseData = response.data;
        const dadosOrdem = responseData.ordem || responseData;
        const listaSaldos = responseData.saldos || [];

        // Pegar movimentacoes do primeiro setor (como era antes)
        const movimentacoes = listaSaldos[0]?.movimentacoes || [];
        console.log(`Carregadas ${movimentacoes.length} movimentações para análise por setor`);

        // Encontrar a movimentação inicial para pegar a data de início
        const movAbertura = movimentacoes.find(m => m.origem === 'ABERTURA');

        this.ordemInfo = {
          id_ordem: this.idOrdem,
          quantidade_planejada: dadosOrdem.quantidade_planejada || 0,
          quantidade_com_erro: dadosOrdem.quantidade_com_erro || 0,
          quantidade_planejada_disponivel: dadosOrdem.quantidade_planejada_disponivel || 0,
          explicacao: dadosOrdem.explicacao || '',
          data_inicio: movAbertura?.data,
          movimentacoes: movimentacoes
        };

        this.saldos = listaSaldos.map(saldo => {
          return {
            ...saldo,
            nome_setor: saldo.nome_setor || 'Setor não especificado',
            entradas: Number(saldo.entradas) || 0,
            saidas: Number(saldo.saidas) || 0,
            produzida: Number(saldo.produzida) || 0,
            transito: Number(saldo.transito) || 0,
            setor_finalizado_com_erro: Number(saldo.setor_finalizado_com_erro) || 0,
            status_aprovacao_recebimento: (saldo.status_aprovacao_recebimento || 'sem_movimento').toLowerCase(),
            status_aprovacao_enviadas: (saldo.status_aprovacao_enviadas || 'sem_movimento').toLowerCase(),
            status_geral: (saldo.status_geral || 'sem_movimento').toLowerCase()
          };
        });

        // Prepara os dados por setor para os cálculos de percentuais e previsões
        if (movimentacoes.length > 0) {
          this.prepararDadosPorSetor();
        }
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        this.ordemInfo = {};
        this.saldos = [];
      } finally {
        this.carregando = false;
      }
    },

    // Método para preparar dados por setor
    prepararDadosPorSetor() {
      if (!this.ordemInfo?.movimentacoes?.length) {
        console.warn('Sem movimentações disponíveis para calcular dados por setor');
        return;
      }

      // Processar cada setor e seus respectivos valores
      const setores = {};

      this.ordemInfo.movimentacoes.forEach(mov => {
        if (!mov.destino || mov.destino === 'ABERTURA') return;

        if (!setores[mov.destino]) {
          setores[mov.destino] = {
            quantidade: 0,
            movimentacoes: []
          };
        }

        setores[mov.destino].quantidade += mov.quantidade || 0;
        setores[mov.destino].movimentacoes.push(mov);
      });

      // Armazenar os dados processados para uso nas computações
      this.dadosPorSetor = setores;

      // Debug
      console.log(`Processados ${Object.keys(setores).length} setores com dados de movimentação`);
    },

    // Cor do chip de aprovação/enviadas
    getChipColor(status) {
      if (!status) return 'grey';
      const statusLower = status.toLowerCase();
      const colorMap = {
        'completa': 'green',
        'completo': 'green',
        'finalizado': 'green',
        'aprovado': 'green',
        'concluido': 'green',
        'parcial': 'orange',
        'pendente': 'orange',
        'em_analise': 'blue',
        'em_andamento': 'blue',
        'aguardando_aprovacao': 'blue',
        'incompleta': 'red',
        'reprovado': 'red',
        'erro': 'red',
        'setor_finalizado_com_erro': 'red',
        'sem': 'grey lighten-2',
        'cancelado': 'grey darken-1'
      };
      return colorMap[statusLower] || 'grey';
    },

    // Cor do chip de status geral
    getGeralColor(status) {
      if (!status) return 'grey';
      switch (status.toLowerCase()) {
        case 'finalizado':
          return 'success';
        case 'pendente':
          return 'warning';
        case 'sem':
        case 'sem':
          return 'grey';
        default:
          return 'grey';
      }
    },

    getProgressColor(progresso) {
      if (progresso >= 100) return 'success';
      if (progresso >= 75) return 'info';
      if (progresso >= 50) return 'primary';
      if (progresso >= 25) return 'warning';
      return 'error';
    },

    // Obtém a quantidade real produzida por um setor a partir da tabela de saldos
    obterQuantidadeRealProduzidaPorSetor(setor) {
      // Procura o setor na lista de saldos
      const saldoSetor = this.saldos.find(s => s.nome_setor === setor);

      if (saldoSetor) {
        // Usamos o valor "produzida" do saldo, que é o valor real produzido pelo setor
        return saldoSetor.produzida || 0;
      }

      // Se não encontrar o setor nos saldos, retorna 0
      return 0;
    },

    // Calcula o tempo restante para um setor específico
    calcularTempoRestantePorSetor(setor, dados) {
      if (!dados || !dados.mediaPorHora) return 'N/D';

      // Pegando a quantidade real produzida pelo setor
      const quantidadeProduzida = this.obterQuantidadeRealProduzidaPorSetor(setor);

      // Verifica se o setor já finalizou
      if (quantidadeProduzida >= this.ordemInfo.quantidade_planejada) {
        return 'Finalizado';
      }

      // Calcular peças restantes para este setor
      const pecasRestantes = this.ordemInfo.quantidade_planejada - quantidadeProduzida;
      if (pecasRestantes <= 0) return 'Finalizado';

      // Calcular tempo necessário com base na média do setor
      if (dados.mediaPorHora <= 0) return 'N/D';

      const horasRestantes = pecasRestantes / dados.mediaPorHora;

      // Formatar o tempo restante
      const dias = Math.floor(horasRestantes / 24);
      const horas = Math.floor(horasRestantes % 24);

      if (dias > 0) return `${dias}d ${horas}h`;
      return `${horas}h`;
    },

    // Calcula a data prevista de término para um setor específico
    calcularPrevisaoTerminoPorSetor(setor, dados) {
      if (!dados || !dados.mediaPorHora) return 'N/D';

      // Pegando a quantidade real produzida pelo setor
      const quantidadeProduzida = this.obterQuantidadeRealProduzidaPorSetor(setor);

      // Verifica se o setor já finalizou
      if (quantidadeProduzida >= this.ordemInfo.quantidade_planejada) {
        return 'Finalizado';
      }

      // Calcular peças restantes para este setor
      const pecasRestantes = this.ordemInfo.quantidade_planejada - quantidadeProduzida;
      if (pecasRestantes <= 0) return 'Finalizado';

      // Calcular tempo necessário com base na média do setor
      if (dados.mediaPorHora <= 0) return 'N/D';

      const horasRestantes = pecasRestantes / dados.mediaPorHora;

      // Calcular data prevista de término
      const dataTermino = new Date();
      dataTermino.setHours(dataTermino.getHours() + horasRestantes);

      return this.formatarData(dataTermino);
    },

    // Formata número para exibição
    formatarNumero(valor) {
      if (valor === null || valor === undefined) return '0';
      return valor.toLocaleString('pt-BR');
    },

    // Formata status para exibição
    formatarStatus(status) {
      if (!status) return 'N/A';
      const statusMap = {
        'sem_movimentacao': 'Sem Movimento',
        'sem_movimento': 'Sem Movimento',
        'aguardando_aprovacao': 'Pendente',
        'em_analise': 'Em Análise',
        'aprovado': 'Aprovado',
        'reprovado': 'Reprovado',
        'completo': 'Concluído',
        'parcial': 'Parcial',
        'pendente': 'Pendente',
        'finalizado': 'Finalizado',
        'setor_finalizado_com_erro': 'Erro no Setor',
        'erro': 'Erro',
        'concluido': 'Concluído',
        'em_andamento': 'Em Andamento',
        'cancelado': 'Cancelado'
      };
      const statusLower = status.toLowerCase();
      if (statusMap[statusLower]) return statusMap[statusLower];
      return status
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },

    // Retorna a cor do chip baseado no valor numérico
    getChipColorForNumber(value, baseColor = 'primary') {
      const numValue = parseFloat(value) || 0;
      if (numValue > 0) {
        return baseColor;
      }
      return 'grey-lighten-1';
    },

    // Formata data para exibição
    formatarData(data) {
      if (!data) return '-';
      const date = new Date(data);
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },

    // Fecha o diálogo principal
    fecharDialog() {
      this.$emit('update:modelValue', false);
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
/* Estilos para a tabela de saldos */
.v-data-table {
  border-radius: 4px;
  overflow: hidden;
  font-size: 0.85rem;
}

.v-data-table :deep(thead) th {
  background-color: #f5f5f5;
  font-weight: 600;
  font-size: 0.75rem;
  color: #424242;
  white-space: nowrap;
  padding: 8px 4px;
  text-align: center;
}

.v-data-table :deep(tbody) td {
  padding: 8px 4px;
}

.v-data-table :deep(tbody) tr:nth-of-type(even) {
  background-color: #fafafa;
}

.v-data-table :deep(tbody) tr:hover {
  background-color: #f0f0f0 !important;
}

.row-concluida {
  background-color: rgba(76, 175, 80, 0.1) !important;
  /* Verde claro para linhas concluídas */
  font-weight: 500;
}

.row-finalizado {
  background-color: rgba(33, 150, 243, 0.1) !important;
  /* Azul claro para finalizado */
  font-weight: 500;
}

.row-erro {
  background-color: rgba(244, 67, 54, 0.1) !important;
  /* Vermelho claro para erros */
  font-weight: 500;
}

.row-concluida:hover {
  background-color: rgba(76, 175, 80, 0.15) !important;
}

/* Estilo para células numéricas */
.v-data-table :deep(td.text-center) {
  text-align: center;
}

/* Cores para os chips de status */
.v-chip--success {
  background-color: #4caf50 !important;
  color: white !important;
}

.v-chip--warning {
  background-color: #ff9800 !important;
  color: white !important;
}

.v-chip--error {
  background-color: #f44336 !important;
  color: white !important;
}

.v-chip--info {
  background-color: #2196f3 !important;
  color: white !important;
}

/* Ajustes para dispositivos móveis */
@media (max-width: 1600px) {
  .v-data-table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .v-data-table :deep(thead) th,
  .v-data-table :deep(td) {
    min-width: 80px;
    font-size: 0.7rem;
  }

  .v-data-table :deep(thead) th:first-child,
  .v-data-table :deep(td:first-child) {
    position: sticky;
    left: 0;
    background-color: white;
    z-index: 2;
  }

  .v-data-table :deep(tbody) tr:hover td:first-child {
    background-color: #f0f0f0;
  }
}

/* Estilos para a tabela */
.v-data-table {
  width: 100%;
  overflow-x: auto;
  font-size: 0.75rem;
}

/* Estilos para os chips */
.v-chip {
  font-size: 0.65rem !important;
  height: 22px !important;
  min-width: 60px;
  justify-content: center;
}

/* Estilos para os cards */
.v-card {
  margin-bottom: 12px;
  border-radius: 8px;
}

/* Ajustes para telas menores que 1024px (tablets) */
@media (max-width: 1024px) {
  .v-data-table {
    font-size: 0.7rem;
  }

  .v-data-table-header th {
    font-size: 0.7rem !important;
    padding: 0 4px !important;
  }

  .v-data-table td {
    padding: 0 4px !important;
  }

  .v-chip {
    font-size: 0.6rem !important;
    height: 20px !important;
    min-width: 50px;
  }

  .v-card__title {
    padding: 12px 16px;
    font-size: 1rem;
  }

  .v-card__text {
    padding: 8px !important;
  }
}

/* Ajustes para telas menores que 768px (tablets pequenos) */
@media (max-width: 768px) {
  .v-data-table {
    font-size: 0.65rem;
  }

  .v-data-table-header th {
    font-size: 0.65rem !important;
    white-space: nowrap;
  }

  .v-chip {
    font-size: 0.55rem !important;
    height: 18px !important;
    min-width: 40px;
  }

  .v-card__title {
    padding: 10px 12px;
    font-size: 0.9rem;
  }

  .v-card__title .v-icon {
    font-size: 1.1rem !important;
  }
}

.v-data-table {
  font-size: 14px;
}

.v-data-table th {
  font-weight: bold;
}

.v-data-table td {
  padding: 8px;
}

/* Estilos para o diálogo de detalhes */
.v-dialog--fullscreen {
  overflow-y: auto;
}

.detail-card {
  margin: 8px;
  transition: all 0.3s ease;
  height: 100%;
}

.detail-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

/* Melhorar a responsividade dos cards de detalhes */
@media (max-width: 600px) {
  .v-card__text .v-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

/* Estilos para o diálogo de detalhes */
.detail-dialog {
  max-height: 90vh !important;
}

.detail-row {
  transition: background-color 0.2s;
}

.detail-row:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

/* Estilo para as abas */
.v-tabs {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.v-tab {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 500;
}

/* Melhorias na responsividade */
@media (max-width: 600px) {
  .v-data-table {
    font-size: 0.75rem;
  }

  .v-data-table-header th,
  .v-data-table td {
    padding: 0 8px !important;
  }

  .v-dialog {
    margin: 16px !important;
    width: calc(100% - 32px) !important;
    max-width: 100% !important;
  }

  .v-window-item {
    padding: 8px !important;
  }
}

/* Melhorias nos cards */
.v-card {
  border-radius: 8px !important;
  overflow: hidden;
}

/* Estilo para os chips de status */
.v-chip {
  font-weight: 500;
  letter-spacing: 0.3px;
}

/* Melhorias na tipografia */
.text-subtitle-2 {
  letter-spacing: 0.1px;
}

/* Ajustes no scroll do diálogo */
.v-dialog>.v-overlay__content>form {
  max-height: 100% !important;
}

/* Ajustes nos botões */
.v-btn {
  text-transform: none;
  letter-spacing: normal;
}
</style>
